import { Box, FormLabel, TextField } from '@mui/material'
import { styled } from '@mui/material/styles'
import classNames from 'classnames'
import Autocomplete from '@mui/material/Autocomplete'
import { Icon } from 'packages/eid-icons'

const DynamicSelectBox = styled(Box)(({ theme }) => ({
    '& label': {
        fontSize: '1.2rem',
        color: 'rgb(180, 180, 180)',
        textTransform: 'uppercase',
    },
}))

const DynamicSelect = styled(Box)(({ theme }) => ({
    '& .MuiFormControl-fullWidth': {
        marginTop: '0.5rem !important',
    },
    '& .MuiOutlinedInput-root': {
        width: '100%',
        boxShadow: '0 0.4rem 0.6rem -0.2rem rgba(0, 0, 0, 0.1)',
        padding: '0.2rem 1rem 0.2rem 2rem',
        borderColor: ' #d8d8dd',
        borderRadius: '0.5rem',
        '& .MuiSelect-select:focus': {
            backgroundColor: 'white',
        },
        '&:before': {
            content: 'none !important',
        },
    },
    '& .MuiChip-root': {
        background: '#f1f1f1',
        border: '0.1rem solid #ccc',
    },
}))

const DynamicSelectSearch = styled(Box)({
    position: 'absolute',
    top: '1.6rem',
    left: '0.8rem',
})

const MultiSelectDropdown = ({
    item,
    t,
    bindRequiredColor,
    ns,
    bindValue,
    handleDDChange,
}) => {
    const handleChange = (e, values) => {
        const evt = {
            target: {
                name: item.fieldName,
                value: values?.length ? prepareSelectedValues(values) : null,
            },
        }
        handleDDChange(evt)
    }

    const prepareSelectedValues = (values) => {
        const selectValue = values.map((item) => {
            return item.value
        })
        return selectValue.toString()
    }

    const bindOptions = () => {
        const values = bindValue(item.fieldName)
        if (!values) {
            return item.options
        } else {
            const nonSelectedValues = item.options.filter((option) => {
                const isValueExist = values
                    .split(',')
                    .find((p) => p === option.value)
                if (!isValueExist) {
                    return option
                }
            })

            return nonSelectedValues
        }
    }

    return (
        <DynamicSelectBox marginTop="1rem">
            <FormLabel
                component="label"
                className={classNames({
                    [bindRequiredColor(item.fieldName)]: true,
                })}
            >
                {(item.localeKey
                    ? t(`${ns}:MsCommonAnonymous_${item.localeKey}`)
                    : item.fieldName) + (item.required ? ' *' : '')}
            </FormLabel>
            <DynamicSelectBox>
                <DynamicSelectSearch>
                    <Icon name="Search" />
                </DynamicSelectSearch>

                <DynamicSelect>
                    <Autocomplete
                        multiple
                        id="multiple-limit-tags"
                        name={item.fieldName}
                        options={bindOptions()}
                        getOptionLabel={(option) =>
                            t(`${ns}:MsCommonAnonymous_${option.localeKey}`)
                        }
                        onChange={handleChange}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                placeholder={t('Common_Search')}
                            />
                        )}
                    />
                </DynamicSelect>
            </DynamicSelectBox>
        </DynamicSelectBox>
    )
}

export default MultiSelectDropdown
